// extracted by mini-css-extract-plugin
export default {"container":"rZLJilB3v6U9Dieo8P6G","logo":"DbppiAwmxlYpr3x0VnVm","card":"JEmt8IohJ3bLZGjQC3Wm","pulse":"hFAZPY72ZPIPVmGd1v9I"};